<template>
  <div>

    <Head title="Wijken" />
    <h1 class="mb-8 text-3xl font-bold">{{ municipalities.total }} Wijken</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset" :showFilter="false">
      </search-filter>
      <Link class="btn-indigo" href="/municipalities/create">
      <span>Aanmaken</span>
      <span class="hidden md:inline">&nbsp;Wijk</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6 cursor-pointer" @click="toggleOrder('deleted_at')">Actief</th>
          <th class="pb-4 pt-6 px-6 cursor-pointer" @click="toggleOrder('zip')">Postcode</th>
          <th class="pb-4 pt-6 px-6 cursor-pointer" @click="toggleOrder('name')">Naam</th>
          <th class="pb-4 pt-6 px-6 cursor-pointer" @click="toggleOrder('users_count')">Gebruikers</th>
          <th class="pb-4 pt-6 px-6 cursor-pointer" @click="toggleOrder('streets_count')">Straten</th>
          <!-- <th class="pb-4 pt-6 px-6 cursor-pointer" @click="toggleOrder('municipality.books_count')">Books</th> -->
        </tr>
        <tr v-for="municipalityItem in municipalities.data" :key="municipalityItem.data.id"
          class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/municipalities/${municipalityItem.data.id}/edit`"
              tabindex="-1">
            {{ municipalityItem.data.active ? '&#10003;' : '' }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/municipalities/${municipalityItem.data.id}/edit`"
              tabindex="-1">
            {{ municipalityItem.data.zip }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/municipalities/${municipalityItem.data.id}/edit`"
              tabindex="-1">
            {{ municipalityItem.data.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/municipalities/${municipalityItem.data.id}/edit`"
              tabindex="-1">
            {{ municipalityItem.data.users_count || ''}}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/municipalities/${municipalityItem.data.id}/edit`"
              tabindex="-1">
            {{ municipalityItem.data.streets_count || ''}}
            </Link>
          </td>

          <td class="w-px border-t">
            <Link class="flex items-center px-4" :href="`/municipalities/${municipalityItem.data.id}/edit`"
              tabindex="-1">
            <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="municipalities.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">Geen wijken gevonden.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="municipalities.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter
  },
  layout: Layout,
  props: {
    filters: Object,    
    order: String,
    direction: String,
    municipalities: Object
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        order: this.order,
        direction: this.direction,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/municipalities', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    toggleOrder(field) {
      this.form.order = field;      
      this.form.direction = this.form.direction === 'asc' ? 'desc' : 'asc'
    }
  },
}
</script>